import styled, {keyframes} from 'vue3-styled-components';

const windowOpen = keyframes`
  0% {
    left: 60px;
  }
  100% {
    left: 0;
  }
`;

const ContainerSc = styled('div')`
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 100vw;
  bottom: 0;
  background: #fff;
  animation: ${windowOpen} 0.3s 1;

  @supports (padding-top: constant(safe-area-inset-top)) or (padding-top: env(safe-area-inset-top)) {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
  }
  * {
    box-sizing: border-box;
  }
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 52px 0 8px;
    width: 100%;

    span {
      margin: 0 auto;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
    }
  }
  .content {
    width: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .search-box {
      margin: 12px 0 12px;
      padding: 0 20px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 44px;
      width: 100%;

      .search-icon {
        position: absolute;
        left: 32px;
        width: 24px;
        height: 24px;
      }
      input {
        height: 100%;
        flex-grow: 1;
        border: none;
        background: #fff;
        box-shadow: 0px 0px 7px 0px rgb(0 0 0 / 4%);
        border-radius: 30px;
        padding: 0 46px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        outline: none;
        caret-color: #2BC689;
      }
      .clear-icon {
        position: absolute;
        right: 25px;
        padding: 11px;
      }
    }
    .search-list {
      width: 100%;
      flex-grow: 1;
      background: #FFFFFF;
      border-radius: 12px 12px 0px 0px;
      flex-shrink: 1;
      overflow: auto;

      .no-person {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding-top: 100px;

        img {
          margin-bottom: 4px;
        }
        .title {
          margin-bottom: 24px;
          font-size: 18px;
          font-weight: 400;
          color: #666666;
          line-height: 25px;
        }
        .sub-title {
          max-width: 254px;
          font-size: 14px;
          font-weight: 400;
          color: #939393;
          line-height: 20px;
          text-align: center;
        }
      }
      .no-result {
        margin-top: 191px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 30px;
        text-align: center;
      }
      .list {
        padding: 6px 20px 40px;

        .item {
          height: 64px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px solid #f8f8f8;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
          .title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            margin-left: 12px;

            .keyword {
              color: #2bc689;
            }
          }
        }
        .item.active {
          .title {
            color: #2bc689;
          }
        }
      }
    }
  }
`;

export {ContainerSc};
